import React, { FC } from 'react';
import Document from '../../../../../../../../../../../interfaces/api/Document';
import { createUseStyles } from '../../../../../../../../../../../theming';
import Chip from '@material-ui/core/Chip';
import api from '../../../../../../../../../../../config/api';

interface Props {
  className?: string;
  attachment: Document;
  onDelete: () => void;
}

const useStyles = createUseStyles({
  root: {
    maxWidth: '100%',
  },
});

const Attachment: FC<Props> = ({ className, attachment, onDelete }) => {
  const classes = useStyles();

  const handleClick = () => {
    const { endpoint } = api.document.download(attachment.id);
    window.open(endpoint, '_blank');
  };

  return (
    <Chip
      classes={{ root: classes.root }}
      className={className}
      variant='outlined'
      size='small'
      label={attachment.filename}
      onDelete={onDelete}
      onClick={handleClick}
    />
  );
};

export default Attachment;
